<template>
  <ResponsiveLayout>
    <template #header_end><HeaderHelp /></template>
    <div class="kds-main-wrapper solera-verification">
      <CorporateHeader />
      <Spinner v-if="loading" />
      <BaseBanner
        v-if="showInfoBanner"
        variant="info"
        class="solera-verification__info-banner"
        scroll-into-view
      >
        <h1 class="solera-verification__info-banner--title">
          {{
            $t('b2b__verification__solera__lookupkey_missing__section1_title')
          }}
        </h1>
        <p
          class="solera-verification__info-banner--description"
          v-html="
            $t('b2b__verification__solera__lookupkey_missing__section1_body')
          "
        ></p>
        <h1 class="solera-verification__info-banner--title">
          {{
            $t('b2b__verification__solera__lookupkey_missing__section2_title')
          }}
        </h1>
        <p
          class="solera-verification__info-banner--description"
          v-html="
            $t('b2b__verification__solera__lookupkey_missing__section2_body')
          "
        ></p>
      </BaseBanner>
      <BaseBanner
        v-if="showNotEligibleBanner"
        variant="warning"
        scroll-into-view
      >
        <p
          v-html="
            $t('b2b_corporate_eligibility_data_not_valid_with_solera_dashboard')
          "
        ></p>
      </BaseBanner>
      <AlreadyHaveAccount />
    </div>
    <template #footer><FooterLinks v-if="!isFromApp()" /></template>
  </ResponsiveLayout>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import useCorporateStore from '@shared/stores/useCorporateStore.js'
import useUsStore from '@us/app/stores/useUsStore.js'
import { useRoute, useRouter } from 'vue-router'

import ROUTE from '@us/app/router/appModule/names'

import BaseBanner from '@shared/components/BaseBanner.vue'
import Spinner from '@shared/components/Spinner.vue'
import AlreadyHaveAccount from '@us/app/components/AlreadyHaveAccount.vue'
import CorporateHeader from '@shared/components/CorporateHeader.vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'
import FooterLinks from '@us/app/components/FooterLinks.vue'
import { isFromApp } from '@shared/helpers/isFromApp.js'
import HeaderHelp from '@us/app/components/HeaderHelp.vue'
import useSharedStore from '@shared/stores/useSharedStore.js'

const corporateStore = useCorporateStore()
const usStore = useUsStore()
const sharedStore = useSharedStore()
const route = useRoute()
const router = useRouter()
const corporate = computed(() => corporateStore.corporate)

const loading = ref(false)
const showNotEligibleBanner = ref(false)
const showInfoBanner = ref(false)

onMounted(async () => {
  let lookupKey = null
  if (!route.query.retry) {
    lookupKey = route.query.lookupKey || sharedStore.initialQuery.lookupKey
  }

  if (!lookupKey) {
    showInfoBanner.value = true
    return
  }

  loading.value = true

  try {
    await usStore.checkCorporateEligibility({
      solera_lookup_key: lookupKey,
      corporate_key: corporate.value.key,
    })

    router.push({
      name: ROUTE.SIGN_UP,
      params: {
        // redirect to the corporate identified during the eligibility check
        corporate_key: usStore.corporateEligibilityData.corporate_key,
      },
    })
  } catch (e) {
    const { response } = e || {}
    const { data, status } = response || {}
    const { errors } = data || {}

    if (status === 403) {
      if (errors?.includes('NOT_ELIGIBLE')) {
        showInfoBanner.value = true
      } else if (errors?.includes('ALREADY_USED')) {
        showInfoBanner.value = true
      } else {
        showNotEligibleBanner.value = true
      }
    } else {
      showNotEligibleBanner.value = true
    }
  } finally {
    loading.value = false
  }
})
</script>

<style lang="scss">
.solera-verification {
  &__info-banner {
    &--title {
      @include kds-typography-title-medium;
    }
  }
}
</style>
